import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" hello word ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" open ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" share ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" open chat ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ag_button_s = _resolveComponent("ag-button-s")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_footer = _resolveComponent("ag-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ag_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ag_text_s, { css: {typography: 'tit22b'} }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ag_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ag_box_s, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.message), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ag_button_s, { onClick: _ctx.onOpen }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_ag_box_s, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.selfUrl), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ag_box_s, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isOpen), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ag_box_s, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.path), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ag_box_s, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isShow), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ag_button_s, { onClick: _ctx.onShare }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_ag_button_s, { onClick: _ctx.onOpenChat }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_ag_footer)
    ]),
    _: 1
  }))
}